import React, { useState } from 'react'
import { taxActions } from '../../action/taxaction';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';
import 'bootstrap';
import Modal from 'bootstrap/js/dist/modal';

const AddTax = ({ onSuccess }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        tax_name: '',
        tax_code: '',
        tax_rate: ''
    });
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'tax_rate' ? (value === '' ? '' : Number(value)) : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation
        if (!formData.tax_name.trim()) {
            Swal.fire('Error', 'Please enter tax name', 'error');
            return;
        }
        
        if (!formData.tax_code.trim()) {
            Swal.fire('Error', 'Please enter tax code', 'error');
            return;
        }
        
        if (formData.tax_rate === '' || formData.tax_rate == null) {
            Swal.fire('Error', 'Please enter tax rate', 'error');
            return;
        }
        
        if (isNaN(formData.tax_rate) || Number(formData.tax_rate) < 0 || Number(formData.tax_rate) > 100) {
            Swal.fire('Error', 'Please enter a valid tax rate between 0 and 100', 'error');
            return;
        }
        
        setLoading(true);
        try {
            const payload = {
                ...formData,
                tax_rate: Number(formData.tax_rate)
            };
            
            await dispatch(taxActions.createTax(payload));
            
            // Reset form
            setFormData({
                tax_name: '',
                tax_code: '',
                tax_rate: ''
            });
            
            // Close modal
            const modal = document.getElementById('add-tax');
            const modalInstance = Modal.getInstance(modal) || new Modal(modal);
            modalInstance.hide();
            
            setTimeout(() => {
                document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                document.body.classList.remove('modal-open');
            }, 200);
            
            // Refresh tax list
            if (onSuccess) onSuccess();
            
        } catch (error) {
            console.error('Error creating tax:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {/* Add Tax */}
            <div className="modal fade" id="add-tax">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Create Tax Rate</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label">Tax Name</label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                name="tax_name"
                                                value={formData.tax_name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Tax Code</label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                name="tax_code"
                                                value={formData.tax_code}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Tax Rate (%)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="tax_rate"
                                                value={formData.tax_rate}
                                                onChange={handleInputChange}
                                                min="0"
                                                max="100"
                                                step="0.01"
                                                required
                                            />
                                        </div>
                                        <div className="modal-footer-btn">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                                disabled={loading}
                                            >
                                                Cancel
                                            </button>
                                            <button 
                                                type="submit" 
                                                className="btn btn-submit"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                        Creating...
                                                    </>
                                                ) : 'Create Tax Rate'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Tax */}
        </div>
    )
}

AddTax.propTypes = {
    onSuccess: PropTypes.func
};

export default AddTax;